import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Dialog, Box, Typography, Button, IconButton } from "@mui/material";
import { X } from "lucide-react";
import { getActiveAlert } from "context/actions/alert";

const BRAND = "#2F4858";

const AlertPopup = () => {
  const router = useRouter();
  const [alert, setAlert] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Админ хэсэгт харуулахгүй
    if (router.pathname.startsWith("/admin")) return;

    let mounted = true;
    (async () => {
      const res = await getActiveAlert();
      const data = res?.data?.data;
      if (!mounted || !data) return;

      // Сесс бүрт нэг удаа (санамж шинэчлэгдвэл дахин харуулна)
      const key = `alert-seen-${data.id}-${data.updatedAt || ""}`;
      if (typeof window !== "undefined" && sessionStorage.getItem(key)) return;

      setAlert(data);
      setOpen(true);
    })();

    return () => {
      mounted = false;
    };
  }, [router.pathname]);

  const handleClose = () => {
    if (alert && typeof window !== "undefined") {
      sessionStorage.setItem(`alert-seen-${alert.id}-${alert.updatedAt || ""}`, "1");
    }
    setOpen(false);
  };

  if (!alert) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { borderRadius: 4, maxWidth: 440, m: 2, overflow: "hidden" } }}
    >
      {/* Close */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 2,
          backgroundColor: "rgba(0,0,0,0.35)",
          color: "#fff",
          "&:hover": { backgroundColor: "rgba(0,0,0,0.55)" },
        }}
        size="small"
      >
        <X size={18} />
      </IconButton>

      {alert.imageUrl && (
        <Box
          component="img"
          src={alert.imageUrl}
          alt={alert.title || "alert"}
          sx={{ width: "100%", maxHeight: 280, objectFit: "cover", display: "block" }}
        />
      )}

      <Box sx={{ p: 3 }}>
        {alert.title && (
          <Typography sx={{ fontSize: 19, fontWeight: 800, color: "#1F2630", mb: 1 }}>
            {alert.title}
          </Typography>
        )}
        {alert.description && (
          <Typography sx={{ fontSize: 14.5, color: "#4B5563", whiteSpace: "pre-line", lineHeight: 1.6 }}>
            {alert.description}
          </Typography>
        )}

        <Button
          onClick={handleClose}
          fullWidth
          variant="contained"
          disableElevation
          sx={{
            mt: 2.5,
            textTransform: "none",
            fontWeight: 700,
            borderRadius: 2,
            backgroundColor: BRAND,
            "&:hover": { backgroundColor: "#22343F" },
          }}
        >
          Хаах
        </Button>
      </Box>
    </Dialog>
  );
};

export default AlertPopup;
